<template>
  <a-modal
    width="50%"
    wrapClassName="full-modal"
    :dialog-style="{ top: '20px' }"
    :visible="visible"
    okText="确定"
    cancelText="取消"
    @ok="handlerSubmit"
    @cancel="() => $emit('hideModal')"
    :afterClose="afterHideEditModal"
  >
    <a-row>
      <a-col span="24" v-for="(item,index) in model" :key="index" style="padding: 10px;text-align: center">
        <img :src="item.url" style="display: inline-block; max-width: 100%"/>
      </a-col>
    </a-row>

  </a-modal>
</template>

<script>
export default {
  name: 'GuideMapModal',
  components:{ },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    model: { type: Array, default: () => [] }
  },
  data (){
    return {

    }
  },
  watch: {
    visible(val){
      console.log(val)
      console.log(this.model)
    },
  },
  methods: {
    handlerSubmit() {
      this.$emit('hideModal')
    },
    // 生成设备标组模态框关闭后，重置相关数据
    afterHideEditModal() {
    },
  }
}
</script>

<style scoped>
:root {
  --el-drawer-padding-primary: 0;
}

body {
  margin: 0;
  background-color: #efefef;
}

.affix-container {
  display: flex;
  justify-content: center;
  flex-direction: row-reverse;
}

.editor {
  width: 500px;
  height: calc(100vh - 36px);
}

.editor .jsoneditor-poweredBy,
.editor .jsoneditor-transform,
.editor .jsoneditor-repair,
.editor .full-screen {
  display: none !important;
}

.workflow {
  padding: 10px;
}

.jsoneditor-menu > button.jsoneditor-copy {
  background-position: -48px 0px;
}

.el-drawer__body {
  padding: 0 !important;
}

.btn-container {
  display: flex;
  height: 42px;
  margin-left: 16px;
}

.slider {
  margin-left: 16px;
  width: 300px;
  display: flex;
}
</style>
